(() => {
  const colors = [
    ['Rojo', '#ff3948', 'hue-rotate(140deg) saturate(1.5)'],
    ['Naranja', '#ff8b38', 'hue-rotate(165deg) saturate(1.4) brightness(1.08)'],
    ['Amarillo', '#ffd34f', 'hue-rotate(195deg) saturate(1.35) brightness(1.12)'],
    ['Rosa', '#ff66a8', 'hue-rotate(110deg) saturate(1.32) brightness(1.08)'],
    ['Blanco', '#ece9ff', 'saturate(.08) brightness(1.35)'],
    ['Verde', '#47d878', 'hue-rotate(-90deg) saturate(1.25)'],
    ['Violeta', '#8b5cf6', 'hue-rotate(55deg) saturate(1.22)'],
    ['Azul', '#2787ff', 'hue-rotate(0deg) saturate(1.15)'],
    ['Cian', '#37d9e8', 'hue-rotate(-35deg) saturate(1.18) brightness(1.05)']
  ];

  document.querySelectorAll('[data-kp-stage]').forEach((stage) => {
    const palette = stage.querySelector('.kp-colors');
    if (!palette) return;

    palette.replaceChildren(...colors.map(([label, swatch, filter]) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'kp-color';
      button.style.setProperty('--swatch', swatch);
      button.dataset.kpFilter = filter;
      button.setAttribute('aria-label', `Luz ${label.toLowerCase()}`);
      button.setAttribute('aria-pressed', String(label === 'Azul'));
      return button;
    }));

    palette.querySelectorAll('[data-kp-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        stage.style.setProperty('--kp-filter', button.dataset.kpFilter);
        palette.querySelectorAll('[data-kp-filter]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === button));
        });
      });
    });
  });
})();
